import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import { IntroduceInfoResponse } from '@/types/api/mypage/introduceInfo';

/** 紹介者トークン発行APIのURL */
const url = ApiUrl.Write.INTRODUCE_CREATE;

/**
 * 紹介者トークン発行APIの呼び出しフック。
 * 紹介URLや紹介キャンペーン導線に必要なトークンを都度発行する。
 *
 * @returns execute - API実行関数
 */
const useCallAPIGetIntroduce = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<IntroduceInfoResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useCallAPIGetIntroduce;
